import React, { Component } from 'react';
import HttpRequestor from '~/components/http_requestor';
import SavingDots from '../shared/saving_dots';
import I18n from '~/utils/translations';

export default class JustMoveIn extends Component {
  constructor(props) {
    super(props);

    const { jmiUrl } = this.props;

    this.state = {
      error: false,
      loading: !jmiUrl,
      jmiUrl,
      errorMessage: null,
    };

    this.requestor = new HttpRequestor();
  }

  componentDidMount() {
    if (!this.state.jmiUrl) {
      this.createAccount();
    } else {
      this.openExternalSite();
    }
  }

  componentDidUpdate() {
    if (this.state.jmiUrl) {
      this.openExternalSite();
    }
  }

  createAccount = () => {
    this.setState({ loading: true });

    this.requestor
      .call(this.props.jmiPath, 'POST')
      .then(() => {
        this.pollAcceptedStatus();
      })
      .catch(this.handleCreateAccountError);
  };

  handleCreateAccountError = async (error) => {
    const errorBody = await Promise.resolve(error).catch((parseError) => {
      console.error(parseError);

      return null;
    });

    if (errorBody) {
      console.error(errorBody);
    }
    this.setState({ loading: false, error: true, errorMessage: errorBody?.error ?? null });
    track_event('just-move-in-flow', 'create-account', 'error');
  };

  pollAcceptedStatus = async () => {
    const pollingInterval = 2000;
    const maxAttempts = 30;
    let attempts = 0;

    const poll = setInterval(async () => {
      try {
        const response = await this.requestor.call(this.props.refreshPath, 'GET');
        const jmiUrl = response.jmi_url;
        if (jmiUrl) {
          clearInterval(poll);
          this.setState({ jmiUrl, loading: false });
        } else {
          attempts++;
          if (attempts >= maxAttempts) {
            clearInterval(poll);
            console.error('Polling exceeded maximum attempts.');
            this.setState({ loading: false, error: true });
          }
        }
      } catch (error) {
        clearInterval(poll);
        console.error(error);
        this.setState({ loading: false, error: true });
      }
    }, pollingInterval);
  };

  openExternalSite = () => {
    window.location.href = this.state.jmiUrl;
  };

  render() {
    const { error, errorMessage, loading } = this.state;

    if (error) {
      return (
        <div className="just-move-in">
          <div>
            <p> {errorMessage || I18n.t('pages.agents_form.error', { email: I18n.t('brand.email') })}</p>
          </div>
        </div>
      );
    }

    if (loading) {
      return (
        <div className="just-move-in">
          <div>
            <p>{I18n.t('pages.just_move_in.description1')}</p>
            <br />
            <p>{I18n.t('pages.just_move_in.description2')}</p>
            <SavingDots className="just-move-in__loading" />
          </div>
        </div>
      );
    }

    return null;
  }
}
